import { Form } from 'react-router';
import type {
  FC,
  FormEventHandler,
  RefObject,
} from 'react'
import {
  TextArea,
  TextInput,
  EmailInput,
  TelInput,
} from '~/components/inputs'
import path from '~/constants/path'

type Props = {
  formRef: RefObject<HTMLFormElement | null>
  onSubmit: FormEventHandler
  inputs: {
    name: string
    email: string
    tel: string
    content: string
  }
  buttonDisabled: boolean
  buttonTitle: string
}

export const InquiryForm: FC<Props> = ({
  formRef,
  onSubmit,
  inputs,
  buttonDisabled,
  buttonTitle,
}) => {
  return (
    <Form method="POST" ref={formRef} onSubmit={onSubmit} className="mt-2 w-full">
      <div className="flex flex-row flex-wrap w-full">
        <div className="basis-full md:basis-1/2 flex flex-row flex-wrap p-2 h-fit">
          <div className="w-full">
            <TextInput id={inputs.name} name={inputs.name} label="お名前" required={true} />
          </div>
          <div className="mt-2 w-full">
            <EmailInput id={inputs.email} name={inputs.email} label="Eメールアドレス" required={true} />
          </div>
          <div className="mt-2 w-full">
            <TelInput id={inputs.tel} name={inputs.tel} label="電話番号" />
          </div>
        </div>
        <div className="basis-full md:basis-1/2 p-2 h-36 md:h-auto">
          <TextArea id={inputs.content} name={inputs.content} label="内容" className="h-auto" required={true} />
        </div>
      </div>
      <div className="mt-4 mb-2 flex flex-row basis-full justify-center">
        <span className="text-xs">
          <a
            className="mx-1 text-blue-500"
            href={path.user.company.policies.privacy}
            target="_blank"
            rel="noopener noreferrer"
          >
            プライバシーポリシー
          </a>
          と
          <a
            className="mx-1 text-blue-500"
            href={path.user.company.policies.terms}
            target="_blank"
            rel="noopener noreferrer"
          >
            利用規約
          </a>
          に同意して
        </span>
      </div>
      <div className="flex flex-row basis-full justify-center">
        <button
          disabled={buttonDisabled}
          className={
            `py-2 bg-primary text-white w-full md:w-1/2 border rounded ${buttonDisabled ? 'bg-gray-500' : ''}`
          }>
          {buttonTitle}
        </button>
      </div>
    </Form>
  )
}
